import { useGet } from '../../HttpClient';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

import { Account } from '@app/models';

export function useWaitForStatementDayChange({
  accountId,
  currentStatementDay,
  enabled = true,
  refetchInterval = 3000,
}: {
  accountId: string;
  currentStatementDay: number;
  enabled?: boolean;
  refetchInterval?: number;
}) {
  const get = useGet(true, "ams");
  const getAccountById = (accountId: string) => {
    return get<Account>(`/api/proxy/ams/account-service/account/${accountId}`);
  };

  return useQueryWithErrorHandling({
    queryKey: ['waitForStatementDayChange', accountId, currentStatementDay],
    queryFn: async () => await getAccountById(accountId),
    refetchInterval: (query) => {
      if (query.state.data?.statementDay == currentStatementDay) {
        return false;
      }
      return refetchInterval;
    },
    enabled: enabled,
  });
}
